export default {
  homePage: {
    navBtnLinks: {
      blog: "Frederic-K's Blog",
      career: "Carrière",
      projects: "Projets",
      about: "À propos",
      contact: "Contact",
      linkedin: "LinkedIn",
      github: "GitHub",
      resume: "CV",
    },
  },
}
